import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const quizQuestionsApi = createApi({
  reducerPath: 'quizQuestionsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getQuizQuestions: builder.query({
      query: (fv_quiz_id) => ({
        url: urls.quizQuestions,
        params: fv_quiz_id ? { fv_quiz_id } : undefined,
      }),
    }),
    getQuizQuestion: builder.query({
      query: (id) => ({ url: urls.quizQuestionDetail(id) }),
    }),
    getQuizQuestionCorrectness: builder.query({
      query: (id) => ({ url: `${urls.quizQuestionDetail(id)}/correctness` }),
    }),
    getQuizQuestionAnswersStats: builder.query({
      query: ({ id, run_id }) => ({
        url: `${urls.quizQuestionDetail(id)}/answers-stats`,
        params: { run_id },
      }),
    }),
    getQuizQuestionCorrectAnswers: builder.query({
      query: ({ id, run_id }) => ({
        url: `${urls.quizQuestionDetail(id)}/correct-answers`,
        params: { run_id },
      }),
    }),
    getQuizQuestionFastestAnswers: builder.query({
      query: ({ id, run_id }) => ({
        url: `${urls.quizQuestionDetail(id)}/fastest-answers`,
        params: { run_id },
      }),
    }),
    saveQuizQuestion: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.quizQuestionDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        }

        const params = req?.fv_quiz_id ? { fv_quiz_id: req.fv_quiz_id } : undefined;

        return {
          url: urls.quizQuestions,
          method: 'POST',
          params,
          data: req.body,
        };
      },
    }),
    deleteQuizQuestion: builder.mutation({
      query(id) {
        return {
          url: urls.quizQuestionDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetQuizQuestionsQuery,
  useGetQuizQuestionQuery,
  useGetQuizQuestionAnswersStatsQuery,
  useGetQuizQuestionCorrectAnswersQuery,
  useGetQuizQuestionFastestAnswersQuery,
  useSaveQuizQuestionMutation,
  useDeleteQuizQuestionMutation,
} = quizQuestionsApi;
